import React from "react";

const DeactivateUser = ({ closeDeactivateUser, handleDeactivate, selectedUser }) => {
  const confirmDeactivate = () => {
    if (handleDeactivate && selectedUser?.id) {
      handleDeactivate(selectedUser.id);
    } else {
      console.error("Deactivate function or user ID is undefined");
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-xl font-semibold text-gray-800 mb-4 text-center">
          Confirmer la désactivation
        </h2>

        <p className="text-gray-600 mb-6">
          Voulez-vous vraiment désactiver{" "}
          <span className="font-semibold text-[#5E17EB]">
            {selectedUser?.name || "cet utilisateur"}
          </span>{" "}
          ? Il ne pourra plus se connecter.
        </p>

        <div className="flex justify-end space-x-4">
          {/* Annuler */}
          <button
            type="button"
            onClick={() => closeDeactivateUser(false)}
            className="bg-[#5E17EB] text-white px-4 py-2 rounded-lg hover:bg-[#4B12C9] transition duration-200"
          >
            Annuler
          </button>

          {/* Désactiver */}
          <button
            type="button"
            onClick={confirmDeactivate}
            className="bg-[#5e17eb] text-white px-4 py-2 rounded-lg hover:bg-[#5A2FE0] transition duration-200"
          >
            Désactiver
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeactivateUser;
